import React, { useEffect, useState } from "react";
import { Button, Checkbox, Form, Input, InputNumber, Select } from "antd";
import MetadataEditorModal from "../MetadataEditorModal";

const EditModalContent = ({
  data,
  setOpen,
  updateCallback,
  allCrops,
  allPlots,
  allVarieties,
  currentSite,
  greenhouseLabel,
}) => {
  const [form] = Form.useForm();
  const [metadataObj, setMetadataObj] = useState(data?.metadata || {});
  const [showMetadataEditor, setShowMetadataEditor] = useState(false);

  useEffect(() => {
    form.setFieldsValue({
      name: data.name,
      crop: data.crop.id,
      plots: data.plots.map((plot) => plot.id),
      varieties: data.varieties.map((variety) => variety.id),
      variety_grown: data.variety_grown,
      over_spec_threshold: data.over_spec_threshold,
      under_spec_threshold: data.under_spec_threshold,
      num_of_rows: data.num_of_rows,
      is_active: data.is_active,
      is_loose: data.is_loose,
      metadata: JSON.stringify(data.metadata, null, 2),
    });
  }, [data, form, greenhouseLabel]);

  const onFinish = (values) => {
    if (greenhouseLabel === "Glasshouse") {
      values.variety_grown = data.variety_grown;
      values.over_spec_threshold = data.over_spec_threshold;
      values.under_spec_threshold = data.under_spec_threshold;
      values.num_of_rows = data.num_of_rows;
    } else {
      values.plots = data.plots.map((plot) => plot.id);
      values.varieties = data.varieties;
    }
    values.metadata = metadataObj;
    values.site = data.site.id;
    // values.crop = data.crop;
    updateCallback(data.id, values);
    setOpen(false);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div className="flex justify-center ">
      <Form
        id="editGreenhouseForm"
        className="max-w-[80%]"
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item
          name="name"
          label="Name"
          initialValue={`${data?.name}`}
          rules={[
            {
              required: true,
              message: "name required",
            },
          ]}
        >
          <Input placeholder="Name" />
        </Form.Item>
        <Form.Item
          name="crop"
          label="Crop"
          initialValue={data?.crop?.id}
          rules={[
            {
              required: true,
              message: "Crop is required",
            },
          ]}
        >
          <Select
            placeholder="Select Crop"
            options={allCrops}
            showSearch
            filterOption={(input, option) =>
              option.label.toLowerCase().includes(input.toLowerCase())
            }
          />
        </Form.Item>
        {greenhouseLabel !== "Glasshouse" && (
          <>
            <Form.Item
              name="variety_grown"
              label="Variety"
              initialValue={data?.variety_grown}
              rules={[
                {
                  required: true,
                  message: "Variety required",
                },
              ]}
            >
              <Input placeholder="Under Spec" />
            </Form.Item>
            <div className="flex items-center justify-between">
              <Form.Item
                name="over_spec_threshold"
                label="Over Spec"
                initialValue={data?.over_spec_threshold}
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <Input placeholder="Over Spec" />
              </Form.Item>
              <Form.Item
                className="pl-2"
                name="under_spec_threshold"
                label="Under Spec"
                initialValue={data?.under_spec_threshold}
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <Input placeholder="Under Spec" />
              </Form.Item>
            </div>
          </>
        )}
        {/* If Glasshouse, show Plots multi-select */}
        {greenhouseLabel === "Glasshouse" && (
          <>
            <Form.Item
              name="plots"
              label="Bays"
              rules={[
                {
                  required: true,
                  message: "Please select at least one plots",
                },
              ]}
            >
              <Select
                mode="multiple"
                placeholder="Select Bays"
                options={allPlots}
                style={{ width: "100%" }}
              />
            </Form.Item>

            <Form.Item name="varieties" label="Varieties">
              <Select
                mode="multiple"
                placeholder="Select Varieties"
                options={allVarieties}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </>
        )}
        <div className="flex items-center justify-between">
          {greenhouseLabel !== "Glasshouse" && (
            <Form.Item
              className="mr-2"
              name="num_of_rows"
              label="#Rows"
              initialValue={data?.num_of_rows}
              rules={[
                {
                  required: true,
                  message: "Num_rows required",
                },
              ]}
            >
              <InputNumber />
            </Form.Item>
          )}
          <Form.Item
            name="is_active"
            valuePropName="checked"
            label="Active"
            initialValue={data?.is_active}
          >
            <Checkbox />
          </Form.Item>
        </div>
        <Form.Item
          name="metadata"
          label="Metadata"
          initialValue={JSON.stringify(data?.metadata)}
          rules={[
            {
              required: false,
              message: "metadata required",
            },
          ]}
        >
          {/*<Input.TextArea />*/}
          <Button color="primary" onClick={() => setShowMetadataEditor(true)}>
            Edit Metadata
          </Button>
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
      <MetadataEditorModal
        name={greenhouseLabel + " Metadata"}
        visible={showMetadataEditor}
        onClose={() => setShowMetadataEditor(false)}
        metadata={metadataObj}
        onUpdateMetadata={(updatedMetadata) => setMetadataObj(updatedMetadata)}
      />
    </div>
  );
};

export default EditModalContent;
